import {
  IUploadOrderFileDTO,
  TPresignedFileResponse,
  getUploadsEndpoints,
  IUploadCommonFileDTO,
  staticUploadsEndpoints,
} from '@/models/uploads.model';
import { ApiResponse, convertModelToFormData, httpClient } from '@/utils';
import axios from 'axios';

class UploadAPI {
  static getOrderUploadUrl({ id, ...params }: Omit<IUploadOrderFileDTO, 'file'>): ApiResponse<TPresignedFileResponse> {
    const { GET_ORDER_PRE_SIGNED } = getUploadsEndpoints({ id });
    return httpClient.get<TPresignedFileResponse>(GET_ORDER_PRE_SIGNED, { params });
  }

  static getCommonUploadUrl(data: Omit<IUploadCommonFileDTO, 'file'>): ApiResponse<TPresignedFileResponse> {
    const { GET_COMMON_PRE_SIGNED } = staticUploadsEndpoints;
    return httpClient.get<TPresignedFileResponse>(GET_COMMON_PRE_SIGNED, { params: data });
  }

  static async uploadCommonFile({ file, ...params }: IUploadCommonFileDTO): Promise<TPresignedFileResponse> {
    const result = await UploadAPI.getCommonUploadUrl(params);
    const data = convertModelToFormData({
      'Content-Type': file?.type,
      ...result.data.fields,
      file,
    });
    await axios.post<TPresignedFileResponse>(result.data.url, data);
    return result.data;
  }

  static async uploadOrderFile({ file, ...params }: IUploadOrderFileDTO): Promise<TPresignedFileResponse> {
    const result = await UploadAPI.getOrderUploadUrl(params);
    const data = convertModelToFormData({
      'Content-Type': file?.type,
      ...result.data.fields,
      file,
    });
    await axios.post<TPresignedFileResponse>(result.data.url, data);
    return result.data;
  }
}

export default UploadAPI;
